import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '@clerk/clerk-react';
import Logo from '@/components/ui/logo';
import { Menu, LogOut } from 'lucide-react';
import { Button } from '@/components/ui/button';

export interface HeaderProps {
  className?: string;
  onMenuClick?: () => void;
}

export const Header: React.FC<HeaderProps> = ({ className = '', onMenuClick }) => {
  const { signOut } = useAuth();

  return (
    <header className={`w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 ${className}`}>
      <div className="container flex h-16 items-center">
        <div className="mr-4 flex items-center">
          <Button
            variant="ghost"
            className="md:hidden mr-2"
            onClick={onMenuClick}
          >
            <Menu className="h-6 w-6" />
          </Button>
          <Link to="/" className="mr-6 flex items-center space-x-2">
            <Logo variant="dark" showText={false} className="h-8 w-auto transition-all duration-300" />
          </Link>
        </div>
        <div className="flex flex-1 items-center justify-end">
          <Button
            variant="ghost"
            onClick={() => signOut()}
            className="inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 hover:bg-accent hover:text-accent-foreground h-9 px-2 md:px-4 py-2"
          >
            <LogOut className="h-5 w-5 md:hidden" />
            <span className="hidden md:inline">Sign Out</span>
          </Button>
        </div>
      </div>
    </header>
  );
};

export default Header; 